import { render, staticRenderFns } from "./createMenu.vue?vue&type=template&id=01129936&scoped=true&"
import script from "./createMenu.vue?vue&type=script&lang=js&"
export * from "./createMenu.vue?vue&type=script&lang=js&"
import style0 from "./createMenu.vue?vue&type=style&index=0&id=01129936&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01129936",
  null
  
)

export default component.exports